module.exports = __webpack_public_path__ + "images/3e5aafb5fea97e156c325dfa762970d4-bg.jpg";